import router from './router'
import RootVue from "@/RootVue.vue";
import { createApp } from 'vue'
import rest from "@/rest/restAccess";
import {defineAsyncComponent} from "vue";

import './interface/Window';

//bootstrapの定義が不足していた場合に一時的にコメントインして確認
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// 全体的に適用するcss。index.htmlにてロードしているのでvue-cli環境では不要だが、ビルド時にSCSSを対象としたいためここに含める。
import './sass/common.scss'
import './sass/bootstrap.scss'
import './sass/btn.scss'

import common from '@/common';

common.runInNextTick(()=>{
  //todo: そのうち必要なモノのみcore-jsでpolifillする。

  //古いブラウザは表示対象外とする。理由は
  //1. session-fix攻撃に対応していない（DBにセッションを保存して複数のシステムで連携かつSSO面倒なので対応してない、よりcsrfトークンを使用できない）
  //2. contentsサーバーのほうのJavascript保護の対応ができてない
  if((window as any).MSInputMethodContext && (document as any).documentMode){
    const msg = "Internet exploreは動作サポートしていません。最新のブラウザ（Chrome、Edge、Firefox等）をお使いください。";
    alert(msg);
    throw msg;
  }

  const app = createApp(RootVue)

  if(process.env.VUE_APP_MODE === "development"){
    app.config.performance = true;
    
    if(process.env.VUE_APP_VUE_CLI){
      require("./initWhenDevelopment");
    }
    
    if(process.env.VUE_APP_USE_DEBUG_FOOTER){
      app.component('DebugFooter',defineAsyncComponent( () => {
        return import('@/component/DebugFooter.vue')
      }))
    }  
  }

  app.config.errorHandler = function (thrownError, vm, vueStackTrace) {
    console.error("error:", thrownError);
    console.error("   vm:", vm);
    console.error("stack trace:", vueStackTrace)
    rest.postStatistics("vue-error", thrownError)
  }

  common.runInNextTick(()=>{
    app.use(router).mount('#app')  
  })
})

